import request from "@/utils/request";

export function contractTotalSettle(data) {
    //获取总结算数据
    return request({
        url: "/icps/system/sign/dataCollection/settle/general/contractTotalSettle",
        method: "post",
        data,
    });
}
export function generalSaveOrUpdate(data) {
    //保存、修改总结算数据
    return request({
        url: "/icps/system/sign/dataCollection/settle/general/saveOrUpdate",
        method: "post",
        data,
    });
}
export function queryList(data) {
    //查询总结算详情
    return request({
        url: "/icps/system/sign/dataCollection/settle/general/queryList",
        method: "post",
        data,
    });
}